import request from '@/api/request'

//消息列表
export function chatList(data) {
    return request({
        url: '/web/chat/list',
        method: 'GET',
        params: data
    })
}


//消息记录
export function messagelist(data) {
    return request({
        url: '/web/chat/messagelist',
        method: 'GET',
        params: data
    })
}

//客服消息记录
export function customerMessageList(data) {
    return request({
        url: '/web/chat/customer/messagelist',
        method: 'GET',
        params: data
    })
}





//客服
export function customerList(data) {
    return request({
        url: '/web/chat/customer/list',
        method: 'GET',
        params: data
    })
}
//PC聊呗-客服分配接口
export function customerShare(data) {
    return request({
        url: '/web/chat/customer/share',
        method: 'GET',
        params: data
    })
}







//平台消息
export function syatemMessage(data) {
    return request({
        url: '/web/chat/syatem/message',
        method: 'GET',
        params: data
    })
}

export function userfriendList(data) {
    return request({
        url: '/web/chat/userfriend/list',
        method: 'GET',
        params: data
    })
}

export function updateFriend(data) {
    return request({
        url: '/web/chat/userfriend/update',
        method: 'Post',
         data
    })
}






//PC聊呗-简历查看
export function resumeInfo(data) {
    return request({
        url: '/web/chat/resume/info',
        method: 'GET',
        params: data
    })
}



//PC聊呗-面试邀请
export function auditAdd(data) {
    return request({
        url: '/web/chat/audit/add',
        method: 'Post',
         data
    })
}


//PC聊呗-面试邀请详情
export function auditInfo(data) {
    return request({
        url: '/web/chat/audit/info',
        method: 'GET',
        params: data
    })
}



//PC聊呗-面试邀请同意/拒绝
export function auditUpdate(data) {
    return request({
        url: '/web/chat/audit/update',
        method: 'POST',
         data
    })
}

//PC聊呗-邀请入职(确认地址)
export function addressAdd(data) {
    return request({
        url: '/web/chat/check/address/add',
        method: 'POST',
         data
    })
}


//PC聊呗-邀请入职(确认地址)详情
export function addressInfo(data) {
    return request({
        url: '/web/chat/check/address/info',
        method: 'get',
        params: data
    })
}

//PC聊呗-职位列表
export function jobList(data) {
    return request({
        url: '/web/chat/job/list',
        method: 'get',
        params: data
    })
}



//PC聊呗-邀请入职同意/拒绝
export function addressUpdate(data) {
    return request({
        url: '/web/chat/check/address/update',
        method: 'POST',
         data
    })
}

///PC聊呗-合同发送
export function contractAdd(data) {
    return request({
        url: '/web/chat/contract/add',
        method: 'POST',
         data
    })
}

export function contractInfo(data) {
    return request({
        url: '/web/chat/contract/info',
        method: 'GET',
        params: data
    })
}

//PC聊呗-合同签署状态修改
export function contractUpdate(data) {
    return request({
        url: '/web/chat/contract/update',
        method: 'POST',
         data
    })
}

//常用语列表
export function wordList(data) {
    return request({
        url: '/web/chat/commonword/list',
        method: 'GET',
        params: data
    })
}

//PC聊呗-常用语添加
export function addWord(data) {
    return request({
        url: '/web/chat/commonword/add',
        method: 'POST',
         data
    })
}


// /PC聊呗-常用语删除
export function delWord(data) {
    return request({
        url: '/web/chat/commonword/del',
        method: 'POST',
         data
    })
}



///PC聊呗-用户手机号微信号
export function weixinPhone(data) {
    return request({
        url: '/web/chat/get/userinfo',
        method: 'GET',
        params: data
    })
}


//发送红包
export function chatUserAddredPack(data) {
    return request({
        url: '/api/chat/user/addredPack',
        method: 'POST',
       data
    })
}

export function chatRedpackInfo(data) {
    return request({
        url: '/api/chat/user/MessageInfo',
        method: 'POST',
       data
    })
}

export function chatMoneyDrawRedpack(data) {
    return request({
        url: '/web/chat/money/draw/redpack',
        method: 'POST',
       data
    })
}



